module.exports = "/shifts/shift-acceptance/shiftAcceptanceInfoIconComponent-eedd11.html";